export enum AvailableOurStudentsFilters {
  academicYear = 'academicYear',
}
